import { atom } from "jotai";

export const globalBooking = atom("Booking");
export const globalAirlineSearch = atom("");
export const globalAirLineMultiSearch = atom([]);